import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class AzDevOps extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <g id="AzDevOps" fillRule="nonzero">
          <polygon points="2.41302388 16.0115362 23.8142035 19.0040844 17.9920815 23.8044873 9.01740981 20.8059843 9.01740981 23.813988"></polygon>
          <polygon points="0 8.82241103 17.9918364 5.39808427 10.5969497 2.02331292e-06 10.5969497 2.47130852 2.41279309 5.67080399"></polygon>
          <polygon points="17.9916198 5.39807389 17.9916198 23.804477 23.8137747 19.0040493 23.8137747 4.33562636"></polygon>
          <polygon points="2.41279309 5.6707883 0 8.82239774 0 15.5633922 2.41279309 16.0115168"></polygon>
        </g>
      </svg>
    );
  }
}

export default AzDevOps;
